import TemplateView from '../TemplateView'

export default class Tab extends TemplateView {
    constructor({
        id = -1,
        text = '',
        extraClass = '',
        onClick = () => {},
    }) {
        super(null)

        this.props = {
            id,
            text,
            onClick,
            extraClass,
        }

        this.state = {
            active: false,
        }

        this.onStateChanged(() => {
            this.$el.toggleClass('active', this.state.active)
        })
    }

    templateHtml() {
        return '<div class="<%-extraClass%> components_tabButton ">' +
               '    <div class="tabText">                             ' +
               '        <%-text%>                                  ' +
               '    </div>                                         ' +
               '</div>                                             '
    }

    templateModel() {
        return {
            ...this.props,
        }
    }

    afterRender() {
        this.$el
            .on('click', () => {
                this.props.onClick(this.props.id)
            })
    }
}



// WEBPACK FOOTER //
// ./web/js/components/Tab.js